import type { FC } from 'react';
import Overlay from '../components/overlay';
import { SvgIcon } from '../components/svg-icon';
import ActionButton from '../components/action-button';
import styles from '../styles/console-logout-popup.module.scss';

const ConsoleLogoutPopup: FC<{
    onOk: () => void;
    onCancel: () => void;
}> = ({ onOk, onCancel }) => {
    return (
        <Overlay>
            <div className={styles.logoutPopup}>
                <button className={styles.closeButton} type="button" onClick={onCancel}>
                    <SvgIcon name="closeCircle" />
                </button>
                <div className={styles.title}>予約管理システムからログアウトします</div>
                <div className={styles.buttons}>
                    <ActionButton
                        className={styles.actionButton}
                        onClick={onCancel}
                        primary={false}
                        title="キャンセル"
                        type="button"
                    />
                    <ActionButton
                        className={styles.actionButton}
                        onClick={onOk}
                        title="実行"
                        type="button"
                    />
                </div>
            </div>
        </Overlay>
    );
};

export default ConsoleLogoutPopup;
